import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container } from "react-bootstrap";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-light text-dark pt-4 pb-3 mt-5 border-top">
      <Container>
        <p className="text-center mb-1 small">
          &copy; {currentYear}{" "}
          <a
            className="text-primary fw-bold text-decoration-none"
            href="https://tungpham42.github.io"
            target="_blank"
            rel="noreferrer"
          >
            Phạm Tùng
          </a>{" "}
          ·{" "}
          <a
            href="https://github.com/tungpham42/chinh-url"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark text-decoration-none"
          >
            <FontAwesomeIcon icon={faGithub} className="me-1" />
            MIT License
          </a>
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
